{
  "#SALES": {
    "TITLE": "Sales",
    "OVERVIEW": "Sales",
    "OVERVIEW_PAGE_TITLE": "Sales Overview",
    "DOCUMENT": "Document Entry",
    "CREATE_DOCUMENT": "Create Document",
    "POSITIONS": {
      "EDIT_TEXT_ARTICLE": "Edit text position",
      "EDIT_MANUAL_ARTICLE": "Edit manual article",
      "EDIT_SECTION": "Edit section text",
      "EDIT_FLATRATE": "Edit flat rate text",
      "EDIT_LINE_TEXT": "Edit line text",
      "ADD_LINE_TEXT": "Add line text",
      "INSERT_ROW_ABOVE": "Insert row above",
      "INSERT_ROW_BELOW": "Insert row below",
      "MOVE_UP": "Move row up",
      "MOVE_DOWN": "Move row down",
      "DUPLICATE": "Duplicate",
      "COPY": "Copy",
      "PASTE": "Paste",
      "TYPE": {
        "SECTION": "Section – groups the positions below it",
        "TEXT": "Text position – plain text, no quantity or price",
        "FLAT_RATE": "Flat rate – charges the positions below it as one price",
        "RETURNABLE": "Deposit – created by the system for its main position",
        "CUSTOMIZABLE": "Manual article – description entered by hand",
        "UNIT": "Unit"
      },
      "MANUAL_DESCRIPTION": "Description changed manually",
      "MANUAL_CHANGE": "Manually changed - the value is not overwritten by price calculation"
    },
    "ACTIONS": {
      "MENU": "Actions",
      "GROUP_EDIT": "Edit",
      "GROUP_STRUCTURE": "Structure",
      "GROUP_CONVERT": "Sum & Convert",
      "GROUP_INSERT": "Insert rows",
      "GROUP_ORDER": "Order",
      "makeTotal": "Set as total",
      "makeSubtotal": "Set as subtotal",
      "makeAlternative": "Set as alternative",
      "makePageBreak": "Page break",
      "removePageBreak": "Remove page break",
      "editDescription": "Edit description",
      "editDocumentNotes": "Document note",
      "addToNewFlatrate": "Add to new flat rate",
      "addToNewSection": "Add to new section",
      "mergeDuplicates": "Merge duplicate positions",
      "undoSection": "Dissolve section",
      "undoFlatrate": "Dissolve flat rate",
      "pickUp": "Pick up",
      "undoPickUp": "Undo pick up",
      "pickUpDigitalStorage": "Pick up digital storage",
      "undoPickUpDigitalStorage": "Undo pick up digital storage",
      "deletable": "Delete",
      "recalculatePrice": "Recalculate price",
      "recalculateCashPrice": "Recalculate cash price"
    },
    "DOCUMENT_NOTES": {
      "TITLE": "Document notes",
      "DELETE": {
        "TITLE": "Delete document note",
        "QUESTION": "Really delete this document note?"
      },
      "MESSAGES": {
        "CREATED": "Document note saved",
        "UPDATED": "Document note updated",
        "DELETED": "Document note deleted"
      }
    },
    "QUERY": {
      "FILTER": {
        "TITLE": "Filter",
        "SEARCH": "Search...",
        "NO_RESULTS": "No results",
        "NO_SELECTED": "Nothing selected",
        "TAB_ALL": "All",
        "TAB_SELECTED": "Selected",
        "SELECT_ALL": "Select all",
        "DESELECT_ALL": "Deselect all",
        "RESET": "Reset",
        "RESET_ALL": "Reset all",
        "ALL": "All",
        "LOAD_ERROR": "Error",
        "APPLY": "Apply",
        "CANCEL": "Cancel",
        "BACK": "Back",
        "STATUS": "Status",
        "CONSTRUCTION_SITES": "Construction sites",
        "USERS": "Users",
        "SALES_ORGS": "Sales organisations",
        "SALES_REPRESENTATIVES": "Sales representatives",
        "PROJECTS": "Projects",
        "WAREHOUSES": "Warehouses",
        "DELIVERY_TOURS": "Delivery tours",
        "AGENTS": "Agents",
        "DISTRIBUTION_TYPES": "Distribution types"
      }
    },
    "EXPLOSIVES_PROOF": {
      "TITLE": "Explosives precursors proof",
      "SUBTITLE": "Record the proof per regulation (EU) 2019/1148",
      "RESTRICTION_REPORTABLE": "Reportable article",
      "RESTRICTION_RESTRICTED": "Restricted article",
      "RESTRICTION_FORBIDDEN": "Forbidden article",
      "RESTRICTION_HYDROGEN_PEROXIDE": "Hydrogen peroxide",
      "PROOF_TYPE": "Proof type",
      "HUNTING_PERMIT": "Hunting license",
      "PRIVATE_PERMIT": "Permit (private)",
      "LICENSE_NUMBER": "Hunting license number",
      "PERMIT_NUMBER": "Permit number",
      "PERMIT_AMOUNT": "Permit amount",
      "PRODUCT_DESCRIPTION": "Product description",
      "CANCEL": "Cancel",
      "WITHOUT_PROOF": "Without proof",
      "APPLY": "Apply"
    },
    "DELETE_ROWS": {
      "TITLE": "Delete row",
      "QUESTION_ONE": "Do you want to delete this row?",
      "QUESTION_MANY": "Do you want to delete these {{count}} rows?",
      "DONT_ASK_AGAIN": "Don't ask again",
      "CANCEL": "Cancel",
      "CONFIRM": "Delete"
    },
    "PRICE_INFO": {
      "MENU": "Price info",
      "TITLE": "Price info",
      "SUBTITLE": "Origin of the price components of this position",
      "EMPTY": "Standard sales price — no special price sources.",
      "CLOSE": "Close",
      "DESCRIPTION": {
        "LISTENPREIS": "List price",
        "NETTOPREIS": "Net price",
        "PREISEBENE": "Price level",
        "KONDITIONEN": "Conditions",
        "DRAUFGABE": "Bonus goods",
        "GUTSCHEIN": "Voucher"
      },
      "ORIGIN": {
        "PREISGRUPPE_KONDBLATT": "Price group condition sheet",
        "PREISEBENE_PREISEBENZU": "Price level surcharge",
        "PREISEBENE_PREISEBENZUL": "Price level surcharge (country)",
        "PREISEBENE_ZUABSCHLAG_AUF": "Surcharge/discount on price level",
        "BEWEAUS": "Labelling movement",
        "LIEFERART": "Delivery type",
        "VKPREIS": "Standard sales price",
        "VKFORG_KONDBLATT": "Sales organisation condition sheet",
        "VERKAUFSART_KONDBLATT": "Sales type condition sheet",
        "KUNDE_KUNDEDBRABATT": "Customer margin discount",
        "KUNDE_KONDBLATT_DBRABATT": "Margin discount from customer condition sheet",
        "KUNDE_KONDBLATT_REF_DBRABATT": "Margin discount from referenced condition sheet",
        "KUNDE_KONDBLATT": "Customer condition sheet",
        "KUNDE_KONDBLATT2": "Second customer condition sheet",
        "KUNDE_KONDBLATT_REF": "Referenced customer condition sheet",
        "KUNDEKONDBLATT_DBRABATT": "Margin discount from customer condition sheet assignment",
        "KUNDEKONDBLATT": "Customer condition sheet assignment",
        "KUNDE_KUNDENKARTE": "Customer card condition sheet",
        "KUNDE_DBRABATT": "Customer margin discount",
        "KUNDE_DBRABATT_PRODUKTGRUPPEDB": "Product group margin discount",
        "ARTSTAMM_MAXRABATT": "Maximum discount of the article",
        "KUNDENGRUPPE_KONDBLATT": "Customer group condition sheet",
        "KUNDENGRUPPE_KONDBLATT_REF": "Referenced customer group condition sheet",
        "KUNDENGRUPPEKONDBLATT": "Customer group condition sheet assignment",
        "KUNDENGRUPPEKONDBLATT_DBRABATT": "Margin discount from customer group condition sheet",
        "KONDBLATT_VORSCHLAG": "Condition sheet proposal",
        "KUNDE_KUNDEAKTION": "Customer promotion",
        "KUNDENGRUPPE_KUNDENGRUPPEAKT": "Customer group promotion",
        "VKFORGAKT": "Sales organisation promotion",
        "VKFORGGRUPPEAKTTION": "Sales organisation group promotion",
        "ERFVARIANTE": "Entry variant",
        "EINKAUFSPREIS": "Purchase price",
        "AKTIONSEKPREIS": "Promotional purchase price",
        "ABVERKAUF": "Sell-off"
      }
    },
    "RECALCULATE_PRICE": {
      "TITLE": "Recalculate price",
      "SUBTITLE": "Run the price calculation for the positions again",
      "PRICE_TYPE": "Price type",
      "LIST_PRICE": "List price",
      "CASH_PRICE": "Cash price",
      "SCOPE": "Scope",
      "SCOPE_SELECTION": "Selection",
      "SCOPE_ALL": "All positions",
      "KEEP_MANUAL_DISCOUNT": "Keep manual discounts",
      "CANCEL": "Cancel",
      "APPLY": "Recalculate"
    },
    "UNIT": {
      "TITLE": "Unit entry",
      "SUBTITLE": "Enter quantities per unit",
      "CHANGE_UNIT": "Change unit",
      "ARTICLE": "Article",
      "QUANTITIES": "Quantities",
      "UNIT": "Unit",
      "UNIT_LOCKED": "The unit cannot be changed for this position.",
      "FACTOR": "Factor",
      "ENTER_QUANTITY": "Enter quantity",
      "TOTAL_IN": "Total in",
      "STOCK": "Stock",
      "TOTAL_STOCK": "Total stock",
      "AVAILABLE": "avail.",
      "QUICK": "Quick",
      "CANCEL": "Cancel",
      "SAVE": "Apply"
    },
    "TEXT_ARTICLE": {
      "TITLE": "Text Position",
      "SUBTITLE": "Edit line text",
      "TEXT": "Text",
      "CANCEL": "Cancel",
      "SAVE": "Save"
    },
    "MULTI_DISCOUNT": {
      "MENU": "Set discount",
      "TITLE": "Set discount",
      "SUBTITLE": "Apply a discount to the selected positions",
      "CONDITION": "Condition",
      "RATE": "Rate in %",
      "RATE_INVALID": "The rate must be between -100 and 100 (negative = surcharge).",
      "ITEMS": "Selected positions",
      "RUNNING": "Applying discount…",
      "SUCCEEDED": "positions updated successfully",
      "FAILED": "positions failed",
      "RETRY": "Retry failed positions",
      "APPLY": "Apply",
      "CANCEL": "Cancel",
      "CLOSE": "Close"
    },
    "FULFILL": {
      "TITLE": "Fulfill from document",
      "SUBTITLE": "Book a position of an open document into this document",
      "HINT": "There are open documents for this article. Instead of capturing it anew, an existing position can be fulfilled.",
      "SOURCE": "Source document",
      "ITEM": "Position",
      "AMOUNT": "Quantity",
      "OPEN": "open:",
      "POSITION_ONE": "position",
      "POSITION_MANY": "positions",
      "AMOUNT_INVALID": "The quantity must be greater than 0.",
      "AMOUNT_INVALID_MAX": "The quantity must be between 0 and the open quantity:",
      "APPLY": "Fulfill",
      "CANCEL": "Capture new",
      "MENU": "Fulfill from document…"
    },
    "MANUAL_ARTICLE": {
      "TITLE": "Manual Article",
      "SUBTITLE": "Edit article text and descriptions",
      "DESIGNATION": "Designation",
      "DESCRIPTION_2": "Article Description 2",
      "DESCRIPTION_3": "Article Description 3",
      "DESCRIPTION_4": "Article Description 4",
      "DESCRIPTION_5": "Article Description 5",
      "SUPPLIER_NUMBER": "Supplier Article No.",
      "EAN": "EAN",
      "DESCRIPTION": "Description",
      "CANCEL": "Cancel",
      "SAVE": "Save"
    },
    "FINALIZE_STEP": {
      "SELECTCONSTRUCTIONSITE": "Select construction site / sub-number",
      "ENTEREXTERNALPURCHASEORDERNUMBER": "Enter external purchase order number",
      "ENTERMANUALADDRESS": "Enter manual address",
      "SELECTDELIVERYDATERANGE": "Select delivery date range",
      "SELECTCOLLECTOR": "Enter collector",
      "PAY": "Complete payment",
      "SIGN": "Capture signature"
    },
    "DOCUMENT_OVERVIEW": {
      "TITLE": "Document Overview",
      "VIEW_ALL": "View all",
      "OPEN": "Open",
      "TOTAL": "Total"
    },
    "SALES_ORGANISATION": "Sales Organisation",
    "DOCUMENT_NUMBER": "Document Number",
    "DOCUMENT_DATE": "Document Date",
    "STATUS": "Status",
    "CUSTOMER": "Customer",
    "CUSTOMER_NAME": "Customer Name",
    "CUSTOMER_NUMBER": "Customer Number",
    "CUSTOMER_SUB_NUMBER": "Customer Sub-Number",
    "INVOICE_CUSTOMER_NUMBER": "Invoice Customer No.",
    "INVOICE_CUSTOMER_NAME": "Invoice Customer Name",
    "VALUE": "Value",
    "TAX_VALUE": "Tax Value",
    "COST": "Cost",
    "CONTRIBUTION_MARGIN": "CM%",
    "CONTRIBUTION_MARGIN_2": "CM",
    "CREATION_TIME": "Created",
    "DOCUMENT_NOTE": "Document Note",
    "ID": "id",
    "SALES_REPRESENTATIVE": "Sales Representative",
    "USER": "User",
    "PROJECT": "Project",
    "PROJECT_NAME": "Project Name",
    "DISTRIBUTION_TYPE": "Distribution Type",
    "BARCODE": "Barcode",
    "INVOICED": "Invoiced",
    "DELIVERED": "Delivered",
    "DELIVERY_DATE": "Delivery Date",
    "CONTRACT_DOCUMENT": "Contract Document",
    "VALID_UNTIL": "Valid Until",
    "INVOICE_APPROVAL": "Invoice Approval",
    "DELIVERY_TOUR": "Delivery Tour",
    "DUE_DATE": "Due Date",
    "PAID": "Paid",
    "REFERENCE_NUMBER": "Reference Number",
    "TRUCK": "Truck",
    "RECEIPT_NUMBER": "Receipt Number",
    "WAREHOUSE": "Warehouse",
    "WORK_ORDER_NUMBER": "Work Order Number",
    "WORK_ORDER_DESCRIPTION": "Work Order Description",
    "WORK_ORDER_STATUS": "Work Order Status",
    "CONFIG": {
      "TITLE": "Sales",
      "SUBTITLE": "Configuration for the sales module",
      "DATE_FROM": "Documents from",
      "DATE_FROM_HINT": "Fixed start date for document queries (overrides months back)",
      "VALID_DOCUMENT_TYPES": "Valid Document Types",
      "VALID_DOCUMENT_TYPES_HINT": "Document types available for selection. Empty = all allowed",
      "ALL_DOCUMENT_TYPES": "All document types",
      "DEFAULT_DOCUMENT_TYPE": "Default Document Type",
      "DEFAULT_DOCUMENT_TYPE_HINT": "Document type pre-selected when creating a new document",
      "NO_DEFAULT": "No default",
      "DASHBOARD_MONTHS_BACK": "Period (months)",
      "DASHBOARD_MONTHS_BACK_HINT": "How many months back to load documents on the dashboard",
      "DEFAULT_DISTRIBUTION_TYPE": "Default Delivery Type",
      "DEFAULT_DISTRIBUTION_TYPE_HINT": "Delivery type pre-selected when creating a new document",
      "SAVE": "Save",
      "SAVED": "Settings saved",
      "AGING_BUCKETS": "Aging buckets",
      "AGING_LABEL": "Label",
      "AGING_FROM_DAYS": "From (days)",
      "AGING_TO_DAYS": "To (days)",
      "AGING_TO_DAYS_OPEN": "Open",
      "AGING_ADD": "Add bucket",
      "AGING_REMOVE": "Remove bucket",
      "AGING_DEFAULT": "Default",
      "AGING_USING_DEFAULTS": "Using default buckets",
      "AGING_CUSTOMIZE": "Customize",
      "AGING_RESET": "Reset to defaults"
    },
    "WIZARD": {
      "NEXT": "Next",
      "CONFIRM": "Confirm",
      "CREATE_DOCUMENT": "Create Document",
      "SELECT_CUSTOMER": "Select Customer",
      "SELECT_CONSTRUCTION_SITE": "Select Construction Site",
      "CONSTRUCTION_SITE": "Construction Site",
      "MANUAL_CONSTRUCTION_SITE": "Manual Construction Site",
      "MANUAL_CONSTRUCTION_SITE_PLACEHOLDER": "Enter manual construction site...",
      "SELECT_DELIVERY_TYPE": "Select Delivery Type",
      "SET_DELIVERY_DATE": "Set Delivery Date",
      "FROM": "From",
      "TO": "To",
      "CALENDAR_WEEK": "Calendar Week",
      "PREFERRED_TIME": "Preferred Delivery Time",
      "DELIVERY_NOTE": "Delivery Note",
      "COLLECTOR": "Collector",
      "COLLECTOR_PLACEHOLDER": "Collector name...",
      "NOTE_PLACEHOLDER": "Enter note..."
    },
    "CREDIT_LIMIT": {
      "TITLE": "Credit Limit",
      "WITHIN_LIMIT": "Within Limit",
      "EXCEEDED": "Limit Exceeded",
      "AVAILABLE": "available",
      "OVERDRAWN": "overdrawn",
      "LOADING": "Loading..."
    },
    "CUSTOMER_PRODUCT": {
      "TITLE": "Customer article history",
      "SEARCH": "Search product …",
      "FROM": "From",
      "TO": "To",
      "CONFIRM": "Insert",
      "CANCEL": "Cancel",
      "EMPTY": "No products in the selected period",
      "NO_TYPES": "Select at least one document type",
      "FAILED": "Query failed — please narrow the period",
      "PRICE_HINT": "The price is recalculated by the document",
      "COL_DATE": "Date",
      "COL_DOCUMENT_TYPE": "Document type",
      "COL_DOCUMENT_NUMBER": "Document no.",
      "COL_PRODUCT_NUMBER": "Product no.",
      "COL_NAME": "Name",
      "COL_QUANTITY": "Quantity",
      "COL_PRICE": "Price",
      "MANUAL_ARTICLE": "Manual article – cannot be inserted",
      "TIMEOUT": "The query exceeded the server's 30 s limit – please narrow the period or select fewer document types"
    },
    "DOCUMENT_DISCOUNTS": {
      "TITLE": "Document discounts",
      "RATE_INVALID": "The rate must be between -100 and 100 (negative = surcharge).",
      "DELETE": {
        "TITLE": "Delete document discount",
        "QUESTION": "Really delete this document discount?"
      },
      "MESSAGES": {
        "CREATED": "Document discount saved",
        "UPDATED": "Document discount updated",
        "DELETED": "Document discount deleted"
      }
    }
  },
  "#DOCUMENT_QUERY": {
    "TITLE": "Document Query"
  },
  "SALES_DOCUMENT": {
    "CREATE": {
      "EXCEPTION": "An error occurred while creating the document."
    },
    "UPDATE": {
      "EXCEPTION": "Beim Update des Belegs ist ein Fehler aufgetreten."
    },
    "READ": {
      "EXCEPTION": "An error occurred while reading the document."
    },
    "DELETE": {
      "EXCEPTION": "Beim Löschen des Belegs ist ein Fehler aufgetreten."
    },
    "FINALIZE": {
      "EXCEPTION": "Beim Abschluss des Belegs ist ein Fehler aufgetreten."
    },
    "VALIDATE": {
      "EXCEPTION": "Beim Prüfen des Belegs ist ein Fehler aufgetreten."
    },
    "COUNTRY": {
      "CANNOT_BE_EMPTY": "Land darf nicht leer sein."
    },
    "DESTINATION_TYPE": {
      "NOT_EDITABLE": "Der Zielbeleg kann nur im Entwurf geändert werden."
    },
    "PAYMENT_METHOD": {
      "DIRECT_DEBIT_INVALID_FOR_CUSTOMER": "Zahlungsart mit Bankeinzug ist bei diesem Kunden nicht gültig!"
    },
    "STORAGE_SITE": {
      "INACTIVE": "Lager ist nicht aktiv."
    },
    "STOCK": {
      "MANDATORY_FIELD": "Lager ist Pflichtfeld.",
      "NOT_PERMITTED_WITH_DISTRIBUTION_TYPE": "Bei dieser Lieferart sind keine Streckenlager erlaubt.",
      "NO_PERMISSION": "Keine Berechtigung für das Lager {{key}}"
    },
    "OBJEKT": {
      "COMPLETED_THEREFORE_INVALID": "Das Objekt ist bereits erledigt, und somit nicht gültig!"
    },
    "CUSTOMER_CARD": {
      "BLOCKED_SINCE": "Kundenkarte ist seit dem {{blockedDate:DATE_DEFAULT}} gesperrt."
    },
    "CUSTOMER": {
      "CANNOT_SWITCH_CUSTOMER_DIFFERENT_CURRENCY": "Auf einen Kunden mit anderer Waehrung darf nicht gewechselt werden.",
      "IS_LOCKED": "Kunde ist gesperrt."
    },
    "LAYOUT": {
      "CANNOT_BE_NULL": "Layout darf nicht null sein."
    },
    "REPRESENTATIVE": {
      "INACTIVE": "Vertreter nicht mehr aktiv."
    },
    "DISTRIBUTION_TYPE": {
      "INACTIVE": "Lieferart nicht aktiv.",
      "INVALID": {
        "PURCHASE_RECEIPT": "Lieferart für Einkaufsbeleg nicht gültig.",
        "SALES_RECEIPT": "Distribution type is not valid for sales receipt."
      },
      "ONLY_INTERNAL_FOR_CUSTOMER": "Es dürfen nur interne Lieferarten für diesen Kunden verwendet werden!",
      "INTERNAL_NOT_ALLOWED_FOR_CUSTOMER": "Es dürfen keine interne Lieferarten für diesen Kunden verwendet werden!",
      "NOT_PERMITTED_MINIMUM_MARGIN": "Lieferart nicht zulässig aufgrund der M-Spanne."
    },
    "ITEM": {
      "NOT_FOUND": {
        "GENERAL": "Bewegung nicht gefunden!",
        "IN_DOCUMENT": "Bewegung in diesem Beleg nicht gefunden!"
      },
      "READ": {
        "EXCEPTION": "Beim Einlesen von Bewegungen in diesem Beleg ist ein Fehler aufgetreten."
      },
      "CREATE": {
        "EXCEPTION": "Beim Erzeugen der Position ist ein Fehler aufgetreten.",
        "MISSING_FIELD": {
          "DESCRIPTION_NO_ITEM": "Zeilentext muss übergeben werden, wenn kein Artikel übergeben wird!"
        }
      },
      "DELETE": {
        "EXCEPTION": "Beim Löschen von Bewegungen in diesem Beleg ist ein Fehler aufgetreten.",
        "RENTAL_BILLING_EXISTS": "Löschen nicht möglich. Es sind Zeilen selektiert, für welche bereits Verleih-Abrechnungen existieren."
      },
      "UPDATE": {
        "EXCEPTION": "Beim Updaten der Position in diesem Beleg ist ein Fehler aufgetreten."
      },
      "PRODUCT": {
        "NOT_FOUND": "Artikel nicht gefunden."
      },
      "POSITION": {
        "ONLY_ALLOWED_FOR_MANUAL_NUMBERING": "Positionsnummer darf nur bei manueller Positionsnummerierung gesetzt werden."
      },
      "CONSUMER_QUANTITY": {
        "NOT_ALLOWED_ON_ITEM_WITH_CHILDREN": "Verrechnungsmenge kann auf einer Bewegung mit Unterbewegungen nicht gesetzt werden."
      },
      "PRICE": {
        "TAX_ID": {
          "NOT_EDITABLE": "Steuersatz für diese Position nicht editierbar.",
          "NOT_ALLOWED_BY_PARENT": "Tax rate {{requested}} is not allowed on this position – the module/flat rate prescribes {{parent}}."
        }
      },
      "PRICE_OF_GOODS": {
        "NET_INCL_NOT_SUPPORTED": "Zahlungsbetrag (inkl. Steuer) kann für den Materialpreis nicht gesetzt werden.",
        "PRICE_INCL_NOT_SUPPORTED": "Preis inkl. Steuer kann für den Materialpreis nicht gesetzt werden.",
        "TAX_ID_NOT_SUPPORTED": "Steuersatz kann für den Materialpreis nicht gesetzt werden."
      },
      "SELLING_TYPE": {
        "CONTAINER_NOT_SUPPORTED": "Verkaufsart mit Behälterhandling wird über diese Schnittstelle nicht unterstützt."
      },
      "COST_CENTER": {
        "NOT_IN_PROJECT": "Kostenstelle nicht im Objekt hinterlegt.",
        "NOT_IN_PROJECT_GROUP": "Kostenstelle nicht in Objektgruppe hinterlegt."
      },
      "CUSTOMIZATION": {
        "NOT_ALLOWED_FOR_PRODUCT": "Manuelle Artikelanpassung ist für diesen Artikel nicht möglich."
      },
      "STOCK": {
        "MUST_NOT_BE_EMPTY": "Lager darf nicht leer sein.",
        "INVALID_FOR_DISTRIBUTION_TYPE": "Ungültiges Lager für aktuelle Lieferart."
      },
      "CASH_DISCOUNT": {
        "EXCEEDS_LIMIT": "Der eingegebene Skontosatz ist zu hoch und kann nicht übernommen werden."
      },
      "DISCOUNT": {
        "CONDITION_ID_MISMATCH": "Die Konditions-ID in Pfad und Anfrage stimmen nicht überein.",
        "NOT_FOUND": "Der Rabatt für diese Kondition wurde auf der Position nicht gefunden."
      },
      "CONFIRMATIONS": {
        "EXCEPTION": "Beim Ermitteln der Bestätigungen ist ein Fehler aufgetreten."
      },
      "DISTRIBUTION_TYPE": {
        "NOT_EDITABLE": "Lieferart ist auf dieser Position nicht editierbar."
      },
      "PRICE_OF_SERVICE": {
        "NET_INCL_NOT_SUPPORTED": "Zahlungsbetrag (inkl. Steuer) kann für den Arbeitspreis nicht gesetzt werden.",
        "PRICE_INCL_NOT_SUPPORTED": "Preis inkl. Steuer kann für den Arbeitspreis nicht gesetzt werden.",
        "TAX_ID_NOT_SUPPORTED": "Steuersatz kann für den Arbeitspreis nicht gesetzt werden."
      },
      "UNDO_FLATRATE": {
        "EXCEPTION": "Beim Auflösen der Pauschale ist ein Fehler aufgetreten.",
        "NOT_FLATRATE_ITEM": "Nur Pauschalartikel können aufgelöst werden."
      },
      "ADD_TO_NEW_FLATRATE": {
        "EXCEPTION": "Beim Erstellen der Pauschale ist ein Fehler aufgetreten.",
        "CONTAINS_FLATRATE": "Die Auswahl darf keine Pauschalartikel enthalten."
      },
      "ADD_TO_NEW_SECTION": {
        "EXCEPTION": "Beim Erstellen des Abschnitts ist ein Fehler aufgetreten."
      },
      "ATTRIBUTE": {
        "UPDATE": {
          "EXCEPTION": "Beim Ändern des Attributs ist ein Fehler aufgetreten."
        },
        "NOT_MODIFIABLE": "Änderung dieses Attributs ist nicht möglich.",
        "PICK_UP": {
          "NOT_ALLOWED_FOR_DISTRIBUTION_TYPE": "Abholschein für Lieferart nicht möglich!"
        },
        "PICK_UP_DIGITAL_STORAGE": {
          "NOT_POSSIBLE": "Abholschein nicht möglich!"
        },
        "CAN_ONLY_BE_SET_VIA_ACTION": "Dieses Attribut kann nur über eine Aktion gesetzt werden.",
        "UNKNOWN": "Unbekanntes Attribut.",
        "PROMOTION": {
          "RESTORE_NOT_REMOVED": "Wiederherstellen der Aktion nicht möglich, da diese nicht entfernt wurde.",
          "REMOVE_ALREADY_REMOVED": "Entfernen der Aktion nicht möglich, da diese bereits entfernt wurde."
        }
      }
    },
    "MANUAL_TERMS_OF_PAYMENT": {
      "EXCEPTION": "Manuellezahlkond konnte nicht gelöscht werden."
    },
    "TERMS_OF_PAYMENT": {
      "EXCEPTION": "Manuellezahlkond konnte nicht gelöscht werden."
    },
    "ADDRESS": {
      "EXCEPTION": "Manadresse konnte nicht gelöscht werden."
    },
    "DELIVERY_ADDRESS": {
      "EXCEPTION": "Lieferadresse (Manadresse) konnte nicht gelöscht werden."
    },
    "PRINT": {
      "EXCEPTION": "Error while printing."
    },
    "DISCOUNT": {
      "CONDITION_NOT_USEABLE_FOR_DOCUMENT_DISCOUNT": "The selected condition is not allowed for document discounts.",
      "CONDITION_ID_MISMATCH": "The condition id in path and body do not match.",
      "NOT_FOUND": "The document has no discount for this condition.",
      "ADD": {
        "EXCEPTION": "An error occurred while adding the document discount."
      },
      "UPDATE": {
        "EXCEPTION": "An error occurred while updating the document discount."
      },
      "DELETE": {
        "EXCEPTION": "An error occurred while deleting the document discount."
      }
    }
  }
}
